// Quick View Drawer Class
class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

// Quick View Button Class
class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      } else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

// Quick View Class
class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          attachAddToCartEvent(drawerContent);
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);

function showCartPopup(productData) {
  const existing = document.querySelector('.cart-popup');
  if (existing) {
    existing.remove();
  }

  const popup = document.createElement('div');
  popup.className = 'cart-popup';

  popup.innerHTML = `
    <div class="cart-popup-content">
      <div class="cart-popup-header">
        <span class="icon">✔</span>
        <span>Item added in your cart</span>
        <button class="cart-popup-close">&times;</button>
      </div>
      <div class="cart-popup-body">
        <img src="${productData.image}" alt="${productData.title}">
        <div class="cart-popup-details">
          <h3>${productData.title}</h3>
          <p class="price">${productData.price}</p>
        </div>
      </div>
      <div class="cart-popup-actions">
        <a href="/cart" class="btn view-cart">View Cart</a>
        <a href="/checkout" class="btn checkout">Checkout</a>
      </div>
    </div>
  `;

  document.body.appendChild(popup);

  popup.querySelector('.cart-popup-close').addEventListener('click', () => {
    popup.remove();
  });
}

function extractPrice(text) {
  const match = text.match(/Rs\.\s*[0-9,]+(\.\d+)?/);
  return match ? match[0] : '';
}

function attachAddToCartEvent(drawerContent) {
  const form = drawerContent.querySelector('form');
  if (form) {
    form.addEventListener('submit', (event) => {
      setTimeout(() => {
        const image = drawerContent.querySelector('.product__media img')?.src || '';
        const title = drawerContent.querySelector('.product__title')?.innerText || 'Product';

        let priceText = '';
        const priceEl = drawerContent.querySelector('.price');
        if (priceEl) {
          priceText = extractPrice(priceEl.innerText);
        }

        const productData = {
          image: image,
          title: title,
          price: priceText
        };

        showCartPopup(productData);
      }, 500);
    });
  }
}

document.addEventListener('cart:updated', () => {
  console.log('Cart updated event triggered');
});

document.addEventListener('submit', (event) => {
  if (event.target.matches('.quick-view__content form')) {
    setTimeout(() => {
      const drawerContent = event.target.closest('.quick-view__content');
      const image = drawerContent.querySelector('.product__media img')?.src || '';
      const title = drawerContent.querySelector('.product__title')?.innerText || 'Product';

      let priceText = '';
      const priceEl = drawerContent.querySelector('.price__regular') || drawerContent.querySelector('.price');
      if (priceEl) {
        priceText = extractPrice(priceEl.innerText);
      }

      const productData = {
        image: image,
        title: title,
        price: priceText
      };

      showCartPopup(productData);
    }, 500);
  }
});
